import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/app/[locale]/error.tsx");
